// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"ContactDetails_buttonsContainer__2XhA_","button":"ContactDetails_button__12_In","phoneAndButtons":"ContactDetails_phoneAndButtons__2LLmK"};